<template>
  <div class="single">
    <Loading v-show="loading"></Loading>
    <h2 id="text">{{ text }}</h2>
    <div class="content" v-show="!loading" v-if="isActive === false">
      <div class="container">
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_a">ぁ</button>
            <audio ref="audioElm_tisai_a" src="../sound/tisai_a.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_ya" class="image">ゃ</button>
            <audio ref="audioElm_tisai_ya" src="../sound/tisai_ya.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_wa" class="image">わ</button>
            <audio ref="audioElm_wa" src="../sound/wa.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ra">ら</button>
            <audio ref="audioElm_ra" src="../sound/ra.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ya">や</button>
            <audio ref="audioElm_ya" src="../sound/ya.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ma">ま</button>
            <audio ref="audioElm_ma" src="../sound/ma.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ha">は</button>
            <audio ref="audioElm_ha" src="../sound/ha.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_na">な</button>
            <audio ref="audioElm_na" src="../sound/na.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ta">た</button>
            <audio ref="audioElm_ta" src="../sound/ta.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_sa">さ</button>
            <audio ref="audioElm_sa" src="../sound/sa.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ka">か</button>
            <audio ref="audioElm_ka" src="../sound/ka.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_a" id="a">あ</button>
            <audio ref="audioElm_a" src="../sound/a.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_i">ぃ</button>
            <audio ref="audioElm_tisai_i" src="../sound/tisai_i.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_yu">ゅ</button>
            <audio ref="audioElm_tisai_yu" src="../sound/tisai_yu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_wo">を</button>
            <audio ref="audioElm_wo" src="../sound/wo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ri">り</button>
            <audio ref="audioElm_ri" src="../sound/ri.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_yu">ゆ</button>
            <audio ref="audioElm_yu" src="../sound/yu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_mi">み</button>
            <audio ref="audioElm_mi" src="../sound/mi.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_hi">ひ</button>
            <audio ref="audioElm_hi" src="../sound/hi.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ni">に</button>
            <audio ref="audioElm_ni" src="../sound/ni.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ti">ち</button>
            <audio ref="audioElm_ti" src="../sound/ti.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_si">し</button>
            <audio ref="audioElm_si" src="../sound/si.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ki">き</button>
            <audio ref="audioElm_ki" src="../sound/ki.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_i">い</button>
            <audio ref="audioElm_i" src="../sound/i.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_u">ぅ</button>
            <audio ref="audioElm_tisai_u" src="../sound/tisai_u.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_yo">ょ</button>
            <audio ref="audioElm_tisai_yo" src="../sound/tisai_yo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nn">ん</button>
            <audio ref="audioElm_nn" src="../sound/nn.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ru">る</button>
            <audio ref="audioElm_ru" src="../sound/ru.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_yo">よ</button>
              <audio ref="audioElm_yo" src="../sound/yo.mp3"></audio>
            </div>
          </article>
          <article class="article-item box">
            <div class="article-inside">
              <button calss="cat" v-on:click="addLast_mu">む</button>
            <audio ref="audioElm_mu" src="../sound/mu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_hu">ふ</button>
            <audio ref="audioElm_hu" src="../sound/hu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nu">ぬ</button>
            <audio ref="audioElm_nu" src="../sound/nu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tu">つ</button>
            <audio ref="audioElm_tu" src="../sound/tu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_su">す</button>
            <audio ref="audioElm_su" src="../sound/su.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ku">く</button>
            <audio ref="audioElm_ku" src="../sound/ku.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_u">う</button>
            <audio ref="audioElm_u" src="../sound/u.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_e">ぇ</button>
            <audio ref="audioElm_tisai_e" src="../sound/tisai_e.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_tu">っ</button>
            <audio ref="audioElm_tisai_tu" src="../sound/tisai_tu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_dakuten">゛</button>
            <audio ref="audioElm_dakuten" src="../sound/dakuten.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_re">れ</button>
            <audio ref="audioElm_re" src="../sound/re.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_me">め</button>
            <audio ref="audioElm_me" src="../sound/me.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button v-on:click="addLast_he">へ</button>
            <audio ref="audioElm_he" src="../sound/he.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ne">ね</button>
            <audio ref="audioElm_ne" src="../sound/ne.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_te">て</button>
            <audio ref="audioElm_te" src="../sound/te.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_se">せ</button>
            <audio ref="audioElm_se" src="../sound/se.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ke">け</button>
            <audio ref="audioElm_ke" src="../sound/ke.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_e">え</button>
            <audio ref="audioElm_e" src="../sound/e.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_o">ぉ</button>
            <audio ref="audioElm_tisai_o" src="../sound/tisai_o.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nobasu">ー</button>
            <audio ref="audioElm_nobasu" src="../sound/nobasu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_handakuten">゜</button>
            <audio ref="audioElm_handakuten" src="../sound/handakuten.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ro">ろ</button>
            <audio ref="audioElm_ro" src="../sound/ro.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_mo">も</button>
            <audio ref="audioElm_mo" src="../sound/mo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ho">ほ</button>
            <audio ref="audioElm_ho" src="../sound/ho.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_no">の</button>
            <audio ref="audioElm_no" src="../sound/no.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_to">と</button>
            <audio ref="audioElm_to" src="../sound/to.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_so">そ</button>
            <audio ref="audioElm_so" src="../sound/so.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ko">こ</button>
            <audio ref="audioElm_ko" src="../sound/ko.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_o">お</button>
            <audio ref="audioElm_o" src="../sound/o.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_0">0</button>
            <audio ref="audioElm_0" src="../sound/0.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_1">1</button>
            <audio ref="audioElm_1" src="../sound/1.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_2">2</button>
            <audio ref="audioElm_2" src="../sound/2.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_3">3</button>
            <audio ref="audioElm_3" src="../sound/3.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_4">4</button>
            <audio ref="audioElm_4" src="../sound/4.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_5">5</button>
            <audio ref="audioElm_5" src="../sound/5.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_6">6</button>
            <audio ref="audioElm_6" src="../sound/6.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_7">7</button>
            <audio ref="audioElm_7" src="../sound/7.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_8">8</button>
            <audio ref="audioElm_8" src="../sound/8.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_9">9</button>
            <audio ref="audioElm_9" src="../sound/9.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"></button>
          </div>
        </article>
        <article class="article-item2 box">
          <div class="article-inside" id="read_delete">
            <button calss="cat" v-on:click="addLast_read">よむ</button>
          </div>
        </article>
        <article class="article-item2 box">
          <div class="article-inside" id="read_delete">
            <button calss="cat" v-on:click="addLast_delete">ぜんぶけす</button>
          </div>
        </article>
        <article class="article-item2 box">
          <div class="article-inside" id="read_delete">
            <button calss="cat" v-on:click="addLast_1delete">1もじけす</button>
          </div>
        </article>
      </div>    
    </div>
    <div class="content2" v-else>
      <div class="container">
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_a"><img src="../assets/cat_tisai_a.png"></button>
            <audio ref="audioElm_tisai_a" src="../sound/tisai_a.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_ya" class="image"><img src="../assets/cat_tisai_ya.png" alt=""></button>
            <audio ref="audioElm_tisai_ya" src="../sound/tisai_ya.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_wa" class="image"><img src="../assets/cat_wa.png" alt=""></button>
            <audio ref="audioElm_wa" src="../sound/wa.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ra"><img src="../assets/cat_ra.png"></button>
            <audio ref="audioElm_ra" src="../sound/ra.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ya"><img src="../assets/cat_ya.png"></button>
            <audio ref="audioElm_ya" src="../sound/ya.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ma"><img src="../assets/cat_ma.png"></button>
            <audio ref="audioElm_ma" src="../sound/ma.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ha"><img src="../assets/cat_ha.png"></button>
            <audio ref="audioElm_ha" src="../sound/ha.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_na"><img src="../assets/cat_na.png"></button>
            <audio ref="audioElm_na" src="../sound/na.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ta"><img src="../assets/cat_ta.png"></button>
            <audio ref="audioElm_ta" src="../sound/ta.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_sa"><img src="../assets/cat_sa.png"></button>
            <audio ref="audioElm_sa" src="../sound/sa.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ka"><img src="../assets/cat_ka.png"></button>
            <audio ref="audioElm_ka" src="../sound/ka.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_a"><img src="../assets/cat_a.png"></button>
            <audio ref="audioElm_a" src="../sound/a.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_i"><img src="../assets/cat_tisai_i.png"></button>
            <audio ref="audioElm_tisai_i" src="../sound/tisai_i.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_yu"><img src="../assets/cat_tisai_yu.png"></button>
            <audio ref="audioElm_tisai_yu" src="../sound/tisai_yu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_wo"><img src="../assets/cat_wo.png"></button>
            <audio ref="audioElm_wo" src="../sound/wo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ri"><img src="../assets/cat_ri.png"></button>
            <audio ref="audioElm_ri" src="../sound/ri.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_yu"><img src="../assets/cat_yu.png"></button>
            <audio ref="audioElm_yu" src="../sound/yu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_mi"><img src="../assets/cat_mi.png"></button>
            <audio ref="audioElm_mi" src="../sound/mi.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_hi"><img src="../assets/cat_hi.png"></button>
            <audio ref="audioElm_hi" src="../sound/hi.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ni"><img src="../assets/cat_ni.png"></button>
            <audio ref="audioElm_ni" src="../sound/ni.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ti"><img src="../assets/cat_ti.png"></button>
            <audio ref="audioElm_ti" src="../sound/ti.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_si"><img src="../assets/cat_si.png"></button>
            <audio ref="audioElm_si" src="../sound/si.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ki"><img src="../assets/cat_ki.png"></button>
            <audio ref="audioElm_ki" src="../sound/ki.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_i"><img src="../assets/cat_i.png"></button>
            <audio ref="audioElm_i" src="../sound/i.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_u"><img src="../assets/cat_tisai_u.png"></button>
            <audio ref="audioElm_tisai_u" src="../sound/tisai_u.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_yo"><img src="../assets/cat_tisai_yo.png"></button>
            <audio ref="audioElm_tisai_yo" src="../sound/tisai_yo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nn"><img src="../assets/cat_nn.png"></button>
            <audio ref="audioElm_nn" src="../sound/nn.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ru"><img src="../assets/cat_ru.png"></button>
            <audio ref="audioElm_ru" src="../sound/ru.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_yo"><img src="../assets/cat_yo.png"></button>
              <audio ref="audioElm_yo" src="../sound/yo.mp3"></audio>
            </div>
          </article>
          <article class="article-item box">
            <div class="article-inside">
              <button calss="cat" v-on:click="addLast_mu"><img src="../assets/cat_mu.png"></button>
            <audio ref="audioElm_mu" src="../sound/mu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_hu"><img src="../assets/cat_hu.png"></button>
            <audio ref="audioElm_hu" src="../sound/hu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nu"><img src="../assets/cat_nu.png"></button>
            <audio ref="audioElm_nu" src="../sound/nu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tu"><img src="../assets/cat_tu.png"></button>
            <audio ref="audioElm_tu" src="../sound/tu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_su"><img src="../assets/cat_su.png"></button>
            <audio ref="audioElm_su" src="../sound/su.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ku"><img src="../assets/cat_ku.png"></button>
            <audio ref="audioElm_ku" src="../sound/ku.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_u"><img src="../assets/cat_u.png"></button>
            <audio ref="audioElm_u" src="../sound/u.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_e"><img src="../assets/cat_tisai_e.png"></button>
            <audio ref="audioElm_tisai_e" src="../sound/tisai_e.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_tu"><img src="../assets/cat_tisai_tu.png"></button>
            <audio ref="audioElm_tisai_tu" src="../sound/tisai_tu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_dakuten"><img src="../assets/cat_dakuten.png"></button>
            <audio ref="audioElm_dakuten" src="../sound/dakuten.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_re"><img src="../assets/cat_re.png"></button>
            <audio ref="audioElm_re" src="../sound/re.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_me"><img src="../assets/cat_me.png"></button>
            <audio ref="audioElm_me" src="../sound/me.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button v-on:click="addLast_he"><img src="../assets/cat_he.png"></button>
            <audio ref="audioElm_he" src="../sound/he.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ne"><img src="../assets/cat_ne.png"></button>
            <audio ref="audioElm_ne" src="../sound/ne.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_te"><img src="../assets/cat_te.png"></button>
            <audio ref="audioElm_te" src="../sound/te.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_se"><img src="../assets/cat_se.png"></button>
            <audio ref="audioElm_se" src="../sound/se.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ke"><img src="../assets/cat_ke.png"></button>
            <audio ref="audioElm_ke" src="../sound/ke.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_e"><img src="../assets/cat_e.png"></button>
            <audio ref="audioElm_e" src="../sound/e.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_o"><img src="../assets/cat_tisai_o.png"></button>
            <audio ref="audioElm_tisai_o" src="../sound/tisai_o.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nobasu"><img src="../assets/cat_nobasu.png"></button>
            <audio ref="audioElm_nobasu" src="../sound/nobasu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_handakuten"><img src="../assets/cat_handakuten.png"></button>
            <audio ref="audioElm_handakuten" src="../sound/handakuten.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ro"><img src="../assets/cat_ro.png"></button>
            <audio ref="audioElm_ro" src="../sound/ro.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_mo"><img src="../assets/cat_mo.png"></button>
            <audio ref="audioElm_mo" src="../sound/mo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ho"><img src="../assets/cat_ho.png"></button>
            <audio ref="audioElm_ho" src="../sound/ho.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_no"><img src="../assets/cat_no.png"></button>
            <audio ref="audioElm_no" src="../sound/no.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_to"><img src="../assets/cat_to.png"></button>
            <audio ref="audioElm_to" src="../sound/to.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_so"><img src="../assets/cat_so.png"></button>
            <audio ref="audioElm_so" src="../sound/so.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ko"><img src="../assets/cat_ko.png"></button>
            <audio ref="audioElm_ko" src="../sound/ko.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_o"><img src="../assets/cat_o.png"></button>
            <audio ref="audioElm_o" src="../sound/o.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_0"><img src="../assets/cat_0.png"></button>
            <audio ref="audioElm_0" src="../sound/0.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_1"><img src="../assets/cat_1.png"></button>
            <audio ref="audioElm_1" src="../sound/1.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_2"><img src="../assets/cat_2.png"></button>
            <audio ref="audioElm_2" src="../sound/2.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_3"><img src="../assets/cat_3.png"></button>
            <audio ref="audioElm_3" src="../sound/3.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_4"><img src="../assets/cat_4.png"></button>
            <audio ref="audioElm_4" src="../sound/4.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_5"><img src="../assets/cat_5.png"></button>
            <audio ref="audioElm_5" src="../sound/5.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_6"><img src="../assets/cat_6.png"></button>
            <audio ref="audioElm_6" src="../sound/6.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_7"><img src="../assets/cat_7.png"></button>
            <audio ref="audioElm_7" src="../sound/7.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_8"><img src="../assets/cat_8.png"></button>
            <audio ref="audioElm_8" src="../sound/8.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_9"><img src="../assets/cat_9.png"></button>
            <audio ref="audioElm_9" src="../sound/9.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>  
        <article class="article-item2 box">
          <div class="article-inside" id="read_delete2">
            <button calss="cat" v-on:click="addLast_read"><img src="../assets/cat_read.png"></button>
          </div>
        </article>
        <article class="article-item2 box">
          <div class="article-inside" id="read_delete2">
            <button calss="cat" v-on:click="addLast_delete"><img src="../assets/delete/cat_delete.png"></button>
          </div>
        </article>
        <article class="article-item2 box">
          <div class="article-inside" id="read_delete2">
            <button calss="cat" v-on:click="addLast_1delete"><img src="../assets/delete/cat_1delete.png"></button>
          </div>
        </article>        
      </div>
    </div>
    <article class="article-item box">
      <div class="article-inside" id="change">
        <button v-on:click="toggle_switch()">みため</button>
      </div>
    </article>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
  export default {
    name: 'Single',
    data () {
      return {
        loading: true,
        text: '',
        showText: false,
        isActive: false
      }
    },
    mounted() {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    components: {
      Loading,
    },
    methods: {
      toggle_switch: function() {
        this.isActive = !this.isActive
      },
      addLast_1delete: function() {
        this.text = this.text.slice(0,-1);
      },
      addLast_0: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '0';
          this.$refs.audioElm_0.play();
        }
      },
      addLast_1: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '1';
          this.$refs.audioElm_1.play();
        }
      },
      addLast_2: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '2';
          this.$refs.audioElm_2.play();
        }
      },
      addLast_3: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '3';
          this.$refs.audioElm_3.play();
        }
      },
      addLast_4: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '4';
          this.$refs.audioElm_4.play();
        }
      },
      addLast_5: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '5';
          this.$refs.audioElm_5.play();
        }
      },
      addLast_6: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '6';
          this.$refs.audioElm_6.play();
        }
      },
      addLast_7: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '7';
          this.$refs.audioElm_7.play();
        }
      },
      addLast_8: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '8';
          this.$refs.audioElm_8.play();
        }
      },
      addLast_9: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += '9';
          this.$refs.audioElm_9.play();
        }
      },
      addLast_a: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'あ';
          this.$refs.audioElm_a.play();
        }
      },
      addLast_ka: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'か';
          this.$refs.audioElm_ka.play();
        }
      },
      addLast_sa: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'さ';
          this.$refs.audioElm_sa.play()
        }
      },
      addLast_ta: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'た';
          this.$refs.audioElm_ta.play()
        }
      },
      addLast_na: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'な';
          this.$refs.audioElm_na.play()
        }
      },
      addLast_ha: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'は';
          this.$refs.audioElm_ha.play()
        }
      },
      addLast_ma: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ま';
          this.$refs.audioElm_ma.play();
        }
      },
      addLast_ya: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'や';
          this.$refs.audioElm_ya.play();
        }
      },
      addLast_ra: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ら';
          this.$refs.audioElm_ra.play();
        }
      },
      addLast_wa: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'わ';
          this.$refs.audioElm_wa.play();
        }
      },
      addLast_tisai_ya: function () {
        if(this.text.length < 15){
          if('き' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'きゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('し' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'しゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('ち' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ちゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('に' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'にゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('ひ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ひゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('み' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'みゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('り' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'りゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('ぢ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぢゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('び' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'びゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('ぴ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぴゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('じ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'じゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
          else if('ぎ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぎゃ';
            this.$refs.audioElm_tisai_ya.play();
          }
        }
      },
      addLast_i: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'い';
          this.$refs.audioElm_i.play();
        }
      },
      addLast_ki: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'き';
          this.$refs.audioElm_ki.play();
        }
      },
      addLast_si: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'し';
          this.$refs.audioElm_si.play();
        }
      },
      addLast_ti: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ち';
          this.$refs.audioElm_ti.play();
        }
      },
      addLast_ni: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'に';
          this.$refs.audioElm_ni.play()
        }
      },
      addLast_hi: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ひ';
          this.$refs.audioElm_hi.play()
        }
      },
      addLast_mi: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'み';
          this.$refs.audioElm_mi.play()
        }
      },
      addLast_yu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ゆ';
        this.$refs.audioElm_yu.play();
        }
      },
      addLast_ri: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'り';
          this.$refs.audioElm_ri.play();
        }
      },
      addLast_wo: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'を';
          this.$refs.audioElm_wo.play();
        }
      },
      addLast_tisai_yu: function () {
        if(this.text.length < 15){
          if('き' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'きゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('し' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'しゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('ち' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ちゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('に' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'にゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('ひ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ひゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('み' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'みゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('り' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'りゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('び' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'びゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('ぴ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぴゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('じ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'じゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('ぢ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぢゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
          else if('ぎ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぎゅ';
            this.$refs.audioElm_tisai_yu.play();
          }
        }
      },
      addLast_tisai_yo: function () {
        if(this.text.length < 15){
          if('き' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'きょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('し' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'しょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('ち' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ちょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('に' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'にょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('ひ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ひょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('み' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'みょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('り' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'りょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('び' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'びょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('ぴ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぴょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('じ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'じょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('ぢ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぢょ';
            this.$refs.audioElm_tisai_yo.play();
          }
          else if('ぎ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぎょ';
            this.$refs.audioElm_tisai_yo.play();
          }
        }
      },
      addLast_nn: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ん';
          this.$refs.audioElm_nn.play();
        }
      },
      addLast_ru: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'る';
          this.$refs.audioElm_ru.play();
        }
      },
      addLast_yo: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'よ';
          this.$refs.audioElm_yo.play();
        }
      },
      addLast_mu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'む';
          this.$refs.audioElm_mu.play();
        }
      },
      addLast_hu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ふ';
          this.$refs.audioElm_hu.play();
        }
      },
      addLast_nu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ぬ';
          this.$refs.audioElm_nu.play();
        }
      },
      addLast_tu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'つ';
          this.$refs.audioElm_tu.play();
        }
      },
      addLast_su: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'す';
          this.$refs.audioElm_su.play();
        }
      },
      addLast_ku: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'く';
          this.$refs.audioElm_ku.play();
        }
      },
      addLast_u: function () {
        if(this.text.length < 15){
        this.showText = !this.showText
        this.text += 'う';
        this.$refs.audioElm_u.play();
        }
      },
      addLast_tisai_tu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'っ';
          this.$refs.audioElm_tisai_tu.play();
        }
      },
      addLast_dakuten: function () {
        if(this.text.length < 16){
          if('か' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'が';
            this.$refs.audioElm_dakuten.play();
          }
          else if('き' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぎ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('く' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぐ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('け' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'げ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('こ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ご';
            this.$refs.audioElm_dakuten.play();
          }
          else if('さ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ざ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('し' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'じ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('す' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ず';
            this.$refs.audioElm_dakuten.play();
          }
          else if('せ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぜ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('そ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぞ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('た' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'だ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('ち' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぢ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('つ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'づ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('て' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'で';
            this.$refs.audioElm_dakuten.play();
          }
          else if('と' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ど';
            this.$refs.audioElm_dakuten.play();
          }
          else if('は' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ば';
            this.$refs.audioElm_dakuten.play();
          }
          else if('ひ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'び';
            this.$refs.audioElm_dakuten.play();
          }
          else if('ふ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぶ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('へ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'べ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('ほ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぼ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('か' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'が';
            this.$refs.audioElm_dakuten.play();
          }
          else if('き' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぎ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('く' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぐ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('け' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'げ';
            this.$refs.audioElm_dakuten.play();
          }
          else if('こ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ご';
            this.$refs.audioElm_dakuten.play();
          }
        }
      },
      addLast_re: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'れ';
          this.$refs.audioElm_re.play();
        }
      },
      addLast_cat: function () {
        this.showText = !this.showText
        this.text += '';
      },
      addLast_me: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'め';
          this.$refs.audioElm_me.play();
        }
      },
      addLast_he: function () {
        if(this.text.length < 15){
          this.showText = !this.showTextd
          this.text += 'へ';
          this.$refs.audioElm_he.play();
        }
      },
      addLast_ne: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ね';
          this.$refs.audioElm_ne.play();
        }
      },
      addLast_te: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'て';
          this.$refs.audioElm_te.play();
        }
      },
      addLast_se: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'せ';
          this.$refs.audioElm_se.play();
        }
      },
      addLast_ke: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'け';
          this.$refs.audioElm_ke.play();
        }
      },
      addLast_e: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'え';
          this.$refs.audioElm_e.play();
        }
      },
      addLast_nobasu: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ー';
          this.$refs.audioElm_nobasu.play();
        }
      },
      addLast_handakuten: function () {
        if(this.text.length < 16){
          if('は' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぱ';
            this.$refs.audioElm_handakuten.play();
          }
          else if('ひ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぴ';
            this.$refs.audioElm_handakuten.play();
          }
          else if('ふ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぷ';
            this.$refs.audioElm_handakuten.play();
          }
          else if('へ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぺ';
            this.$refs.audioElm_handakuten.play();
          }
          else if('ほ' === this.text.slice(-1)){
            this.showText = !this.showText
            this.text = this.text.slice(0,-1);
            this.text += 'ぽ';
            this.$refs.audioElm_handakuten.play();
          }
        }
      },
      addLast_ro: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ろ';
          this.$refs.audioElm_ro.play();
        }
      },
      addLast_mo: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'も';
          this.$refs.audioElm_mo.play();
        }
      },
      addLast_ho: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ほ';
          this.$refs.audioElm_ho.play();
        }
      },
      addLast_no: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'の';
          this.$refs.audioElm_no.play();
        }
      },
      addLast_to: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'と';
          this.$refs.audioElm_to.play();
        }
      },
      addLast_so: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'そ';
          this.$refs.audioElm_so.play();
        }
      },
      addLast_ko: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'こ';
          this.$refs.audioElm_ko.play();
        }
      },
      addLast_o: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'お';
          this.$refs.audioElm_o.play();
        }
      },
      addLast_tisai_a: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ぁ';
          this.$refs.audioElm_tisai_a.play();
        }
      },
      addLast_tisai_i: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ぃ';
          this.$refs.audioElm_tisai_i.play();
        }
      },
      addLast_tisai_u: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ぅ';
          this.$refs.audioElm_tisai_u.play();
        }
      },
      addLast_tisai_e: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ぇ';
          this.$refs.audioElm_tisai_e.play();
        }
      },
      addLast_tisai_o: function () {
        if(this.text.length < 15){
          this.showText = !this.showText
          this.text += 'ぉ';
          this.$refs.audioElm_tisai_o.play();
        }
      },
      addLast_delete: function () {
        this.showText = !this.showText
        this.text = ''
      },
      addLast_read: function () {
        if ('speechSynthesis' in window) {
          //音声出力APIのインスタンス生成
          var synthes = new SpeechSynthesisUtterance();
          //音声出力APIにパラメータを設定
          synthes.voiceURI = 1;            // 出力する音声の種類 
          synthes.volume = 1;              // 出力する音声のボリューム
          synthes.rate = 0.6;                // 出力する音声の速さ
          synthes.pitch = 1;               // 出力する音声のピッチ(高さ)
          synthes.text = this.text;     // 出力する文章
          synthes.lang = 'ja-JP';          // 出力する音声の言語 
          //音声出力
          speechSynthesis.speak( synthes );
        } else {
          alert("このブラウザは音声合成に対応していません。")
        }
      },
    }
  }
</script>



<style scoped>
.content {
  margin: 0 auto;
  /* 外枠の大きさ */
  max-width: 880px;
  /* border: 1px solid black; */
  min-height: 500px;
}

.content2 {
  margin: 0 auto;
  /* 外枠の大きさ */
  max-width: 880px;
  /* border: 1px solid black; */
  min-height: 500px;
}

/* 記事全ての枠の設定 */
.container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  /* 記事折り返し設定 */
  margin: 0px auto 80 auto 0px auto 80 auto;
}

.article-item {
  /* 記事アイテムの一つの大きさ */
  width: 8.3%;
  height: auto;
  margin-bottom: 0px;
}

.article-item2 {
  /* 記事アイテムの一つの大きさ */
  width: 33%;
  height: auto;
  margin-bottom: 0px;
}

.article-item button img{
  /* 画像は親要素に対して100%にする */
  width: 103%;
  height: 100%;
}

.article-item p {
  padding: 0px 10px;
}


#text{
  background: white;
  height: 80px;
  font-size: 45px;
}

.single, text {
    background:(0, 0, 0);
}

.About{
    background-color: rgb(166, 214, 214);
}

table{
    width:100;
    text-align: left;
}
table th{
  padding: 12px;
}
table tb{
    padding: 12px;
}
table tr:nth-of-type(even){
    background-color: rgba(0, 0, 255, 0.1);
}

.cat{
    cursor: pointer;
    padding: 5px 5px;
    color: rgb(166, 214, 214);
    background-color: rgb(166, 214, 214);
    transition: background-color .2s
}

.cat:hover{
    color: #ffffff;
    background-color: #000000;
}

.cat:active{
    background-color: rgb(166, 214, 214);
}

button:disabled{
    opacity: 0.1;
    pointer-events: none;
}


button{
    outline: none;
    cursor: pointer;
    padding: 3px 3px;
    color: rgb(166, 214, 214);
    background-color: rgb(166, 214, 214);
    transition: background-color .2s
}

button:hover{
    color: #000000;
    border: 0px;
    opacity:0.5;
    background-color: ;
}

button:active{
    background-color: rgb(166, 214, 214);
}

button:disabled{
    opacity: .5;
    pointer-events: none;
}

.single2{
    background-color: rgb(166, 214, 214);
}

table{
    width:100;
    text-align: left;
}
table th{
  padding: 12px;
  border-bottom: 2px solid darkgrey;
}
table tb{
    padding: 12px;
}
table tr:nth-of-type(even){
    background-color: rgba(0, 0, 255, 0.1);
}
button{
    margin: 2px;
    cursor: pointer;
    padding: 3px 3px;
    border-radius: 6px;
    color: #ffffff;
    border: 0px;
    background-color: #5e6e78;
    transition: background-color .2s;
    width: 60px;
    height: 62px;
    font-size: 48px;
}
.single{
    background-color: #ccdce5;
}

button:hover{
    background-color: #ffffff;
}

button:active{
    background-color: #ffffff;
}

button:disabled{
    opacity: .5;
    pointer-events: none;
}

@font-face {
    font-family: minmoji;
    src: url('https://minmoji.ucda.jp/fontseot/https%3A__brushtalk-5c0f3.web.app_');
    src: local('minmoji'),
        url('https://minmoji.ucda.jp/fontswoff/https%3A__brushtalk-5c0f3.web.app_') format('woff'),
        url('https://minmoji.ucda.jp/fonts/https%3A__brushtalk-5c0f3.web.app_') format('opentype');
  }

  .single {
    font-family: minmoji;
  }
#a {
  background-color: #e86d6a;
  width: 60px;
  height: 62px;
}

#a:hover{
    background-color: #ffffff;
}

#a:active{
    background-color: #ffffff;
}

#a:disabled{
    opacity: .5;
    pointer-events: none;
}

.content2 button{
  background: #ccdce5;
}

.content2 button:hover{
    background-color: #ffffff;
}

.content2 button:active{
    background-color: #ffffff;
}

.content2 button:disabled{
    opacity: .5;
    pointer-events: none;
}

#read_delete2 button{
  width: 200px;
  height: 64px;
}

#read_delete2{
  height: 140px;
}

#change button{
  width: 250px;
  height: 60px;
}

#read_delete button{
  writing-mode: horizontal-tb;
  width: 280px;
  height: 62px;
}

#read_delete {
  height: 125;
}

</style>